import React, { useState } from 'react';
import { Modal, message } from 'antd';
import CreditNoteList from './CreditNoteList';
import CreditNoteForm from './CreditNoteForm';
import creditNoteService, { CreditNote } from '../../../../services/creditNoteService';
import { useTranslation } from "react-i18next";

type Mode = 'create' | 'edit' | 'view' | 'duplicate' | null;

const CreditNoteManagement: React.FC = () => {
    const { t } = useTranslation();
  const [mode, setMode] = useState<Mode>(null);
  const [current, setCurrent] = useState<CreditNote | null>(null);
  const [refresh, setRefresh] = useState(0);

  const closeForm = () => { setMode(null); setCurrent(null); };
  const bumpRefresh = () => setRefresh(n => n + 1);

  const handleDelete = (cn: CreditNote) => {
    Modal.confirm({
      title: t('Delete {{creditNoteNo}}?', { creditNoteNo: cn.creditNoteNo }),
      content:
        cn.status === 'CANCELLED'
          ? t('This credit note has already been cancelled, so the ledger is square — its reversing entry stays in place. The document and its lines are removed, and a copy is kept so it can be restored.')
          : t('The credit note and its lines are removed. A copy is kept so it can be restored.'),
      okType: 'danger',
      onOk: async () => {
        try {
          await creditNoteService.deleteCreditNote(cn.id);
          message.success(t('Credit note deleted'));
          bumpRefresh();
        } catch (err: any) {
          message.error(err?.message || t('Failed to delete'));
        }
      }
    });
  };

  return (
    <>
      <CreditNoteList
        refresh={refresh}
        onCreate={() => { setMode('create'); setCurrent(null); }}
        onView={(cn) => { setMode('view'); setCurrent(cn); }}
        onEdit={(cn) => { setMode('edit'); setCurrent(cn); }}
        onDuplicate={(cn) => { setMode('duplicate'); setCurrent(cn); }}
        onPost={(cn) => { setMode('edit'); setCurrent(cn); }}
        onCancel={(cn) => { setMode('view'); setCurrent(cn); }}
        onDelete={handleDelete}
      />
      {mode && (
        <CreditNoteForm
          mode={mode}
          initialValue={current}
          onClose={closeForm}
          onSaved={() => { closeForm(); bumpRefresh(); }}
        />
      )}
    </>
  );
};

export default CreditNoteManagement;
